import { ReactComponent as BannerIcon } from '../../icons/marketing-banners-icon.svg';
import { ReactComponent as FlyerIcon } from '../../icons/marketing-flyer-icon.svg';
import { ReactComponent as MailingIcon } from '../../icons/marketing-mailing-icon.svg';
import { ReactComponent as SocialMediaIcon } from '../../icons/marketing-social-media-icon.svg';
import { ReactComponent as TeachingMediaIcon } from '../../icons/marketing-teaching-icon.svg';
import ProductInstructionsHero from '../../images/instrukcje_produktów_420x240px.png';
import SocialMediaImage from '../../images/materiały_do_social_media_420x240px.png';
import TeachingMaterialsHero from '../../images/materiały_szkoleniowe_420x240px.png';
import EmailsHero from '../../images/szablony_emaili_do_klientów_420x240px.png';
import FlyersHero from '../../images/ulotki_o_produktach_420x240px.png';

export const resources = [
  {
    id: 1,
    label: 'Teaching materials',
    hero: TeachingMaterialsHero,
    icon: <TeachingMediaIcon />,
    intro: 'Teaching materials intro',
    links: [
      {
        label: 'Factoring Online Marketing Resources Label',
        description: 'Factoring Online Marketing Resources Description',
        url: 'https://www.youtube.com/watch?v=8eipbBW36SQ',
        type: 'video',
      },
      {
        label: 'Financing individual invoices Marketing Resources Label',
        description: 'Financing individual invoices Marketing Resources Description',
        url: 'https://www.youtube.com/watch?v=mal0_4cIoN0',
        type: 'video',
      },
      {
        label: 'Deferred payment Marketing Resources Label',
        description: 'Deferred payment Marketing Resources Description',
        url: 'https://youtu.be/R7VKCkLEPvA',
        type: 'video',
      },
      {
        label: 'Financing Zus Label',
        description: 'Financing Zus Description',
        url: 'https://www.youtube.com/watch?v=4km8CEXCGiI',
        type: 'video',
      },
      {
        label: 'Online presentations',
        url: 'https://cdn.pragmago.pl/marketing/broker/prezentacja-szkolenie-broker2025.pdf',
        type: 'link',
      },
    ],
  },
  {
    id: 2,
    label: 'Product flyers',
    hero: FlyersHero,
    icon: <FlyerIcon />,
    intro: 'Product flyers intro',
    links: [
      {
        label: 'Factoring Online Marketing',
        url: 'https://pragma.link/OnePager-Faktoring',
        type: 'link',
      },
      {
        label: 'Reverse Factoring Marketing',
        url: 'https://cdn.pragmago.pl/marketing/broker/eulotka-faktoring-odwrotny-broker.pdf',
        type: 'link',
      },
      {
        label: 'Mortgage loan (advance payment) Marketing',
        url: 'https://cdn.pragmago.pl/marketing/broker/eulotka-pozyczka-hipoteczna-zaliczka-broker.pdf',
        type: 'link',
      },
      {
        label: 'Loan against turnover from the terminal Marketing',
        url: 'https://cdn.pragmago.pl/marketing/broker/eulotka-pozyczka-pod-obroty-z-terminala-broker.pdf',
        type: 'link',
      },
      {
        label: 'Financing individual invoices',
        url: 'https://pragma.link/Finansowanie-pojedynczych-faktur',
        type: 'link',
      },
      {
        label: 'Revolving loan',
        url: 'https://pragma.link/OnePager-Pozyczka-odnawialna',
        type: 'link',
      },
      {
        label: 'Tax financing',
        url: 'https://pragma.link/OnePager-Finansowanie-podatkow',
        type: 'link',
      },
      {
        label: 'Marketing Integration all products',
        url: 'https://pragma.link/OnePager-4-produkty',
        type: 'link',
      },
    ],
  },
  {
    id: 3,
    label: 'Email templates for customers',
    hero: EmailsHero,
    icon: <MailingIcon />,
    intro: 'Email templates for customers intro',
    links: [
      {
        label: 'Factoring Online Marketing',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/faktoring-online-szablon-email.zip',
        type: 'file',
      },
      {
        label: 'Reverse Factoring Marketing',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/faktoring-odwrotny-szablon-email.zip',
        type: 'file',
      },
      {
        label: 'Mortgage loan (advance payment) Marketing',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/pozyczka-zaliczka-hipoteczna-szablon-email.zip',
        type: 'file',
      },
      {
        label: 'Loan against turnover from the terminal Marketing',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/pozyczka-pod-obroty-z-terminala-szablon-email.zip',
        type: 'file',
      },
      {
        label: 'Financing individual invoices',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/finansowanie-pojedynczych-faktur-szablon-email.zip',
        type: 'file',
      },
      {
        label: 'Revolving loan',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/pozyczka-odnawialna-szablon-email.zip',
        type: 'file',
      },
      {
        label: 'Tax financing',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/finansowanie-podatkow-szablon-email.zip',
        type: 'file',
      },
    ],
  },
  {
    id: 4,
    label: 'Product instructions',
    hero: ProductInstructionsHero,
    icon: <BannerIcon />,
    intro: 'Product instructions intro',
    links: [
      {
        label: 'Factoring Online Marketing',
        url: 'https://bit.ly/KartaInstrukcjiFaktoringOnlinePragmaGO',
        type: 'link',
      },
      {
        label: 'Financing individual invoices',
        url: 'https://pragma.link/broker-instrukcja-finansowanie-faktur',
        type: 'link',
      },
      {
        label: 'Revolving loan',
        url: 'https://pragma.link/broker-instrukcja-pozyczka-odnawialna',
        type: 'link',
      },
      {
        label: 'Tax financing',
        url: 'https://pragma.link/broker-instrukcja-finansowanie-podatkow',
        type: 'link',
      },
    ],
  },
  {
    id: 5,
    label: 'Social media materials',
    hero: SocialMediaImage,
    icon: <SocialMediaIcon />,
    intro: 'Social media materials intro',
    links: [
      {
        label: 'Factoring Online Marketing',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/faktoring-online-stala-umowa-SM.zip',
        type: 'file',
      },
      {
        label: 'Reverse Factoring Marketing',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/faktoring-odwrotny-SM.zip',
        type: 'file',
      },
      {
        label: 'Mortgage loan (advance payment) Marketing',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/pozyczka-zaliczka-hipoteczna-SM.zip',
        type: 'file',
      },
      {
        label: 'Loan against turnover from the terminal Marketing',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/pozyczka-pod-obroty-z-terminala-SM.zip',
        type: 'file',
      },
      {
        label: 'Financing individual invoices',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/finansowanie-pojedynczych-faktur-SM.zip',
        type: 'file',
      },
      {
        label: 'Revolving loan',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/pozyczka-odnawialna-SM.zip',
        type: 'file',
      },
      {
        label: 'Tax financing',
        url: 'https://cdn.pragmago.pl/marketing/StrefaBrokera/finansowanie-podatkow-SM.zip',
        type: 'file',
      },
    ],
  },
];

export const getSelectedMarketingMaterials = (selectedId) => resources.filter(({ id }) => id === selectedId);
